export var DatabaseType;
(function (DatabaseType) {
    DatabaseType[DatabaseType["HTTP"] = 0] = "HTTP";
    DatabaseType[DatabaseType["LOCAL_STORAGE"] = 1] = "LOCAL_STORAGE";
})(DatabaseType || (DatabaseType = {}));
const configuration = {
    "domain": "http://localhost/",
    "database": __DATABASE__,
};
export function getConfiguration() {
    return configuration;
}
